import Client from './client';

export default class ChannelOrderAcceptances extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/shopify/markets/orders/acceptance`, options);
  }

  putById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/shopify/markets/orders/acceptance/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
